// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-card .md-card-content[data-v-8aa9dd90]{overflow:auto}", ""]);
// Exports
module.exports = exports;
